"use client";

import { Info } from "lucide-react";

import type { WalletInfoBannerDTO } from "../../types/cms/profile-page";

interface WalletInfoBannerProps {
  cms: WalletInfoBannerDTO;
}

export function WalletInfoBanner({ cms }: Readonly<WalletInfoBannerProps>) {
  return (
    <div
      className="flex items-start gap-3 rounded-md bg-brand-blue-40 border border-brand-blue-30 px-2 py-1"
      data-testid="wallet-info-banner"
    >
      <Info className="h-5 w-5 text-brand-blue shrink-0 mt-0.5" aria-hidden="true" />
      <p className="text-sm text-gray-700">{cms.message}</p>
    </div>
  );
}
